<template>
  <div class="layout-default">
    <el-container style="display: flex;flex-direction: column;min-height: 100vh;">
<!--      <el-header height>-->
<!--        <my-header/>-->
<!--      </el-header>-->
      <el-main>
        <router-view></router-view>
      </el-main>
<!--      <el-footer height>-->
<!--        <my-footer/>-->
<!--      </el-footer>-->
    </el-container>
  </div>
</template>

<script>
import MyHeader from '../../src/components/header'
import MyFooter from '../../src/components/footer'

export default {
  components: {
    MyHeader,
    MyFooter,
  }
}
</script>

<style lang="scss" scoped>
.el-header {
  padding: 0;
}

.el-main {
  padding: 0;
}

.el-footer {
  padding: 0;
}
</style>
